import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const TabletPageConfig = {
  settings: {
    layout: {
      config: {
        scroll: 'content',
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        mode: 'fullwidth',
      },
    },
    customScrollbars: false,
  },
  routes: [
    {
      path: routesUrl.tabletPage,
      component: React.lazy(() => import('./components/TabletPage')),
    },
  ],
};

export default TabletPageConfig;
